import React from 'react';
import LoginForm from './LoginForm.js';

const Login = () => (
  <>
    <LoginForm />
  </>
);

export default Login;
